<div>
    <mat-tab-group mat-align-tabs="center">
        <mat-tab label="Incidents">
            <app-installation-incidents-list [installation]="installation"></app-installation-incidents-list>
        </mat-tab>
        <mat-tab label="Rapports d'erreurs">
            <app-installation-error-reports [installation]="installation"></app-installation-error-reports>
        </mat-tab>
    </mat-tab-group>
</div>